<!-- 知识付费 -->
<template>
  <div class="warp">
    <div class="knowledgePayBanner">
      <p>绿茶知识付费系统</p>
      <span>
        解决知识付费的多渠道变现
        <br />会员销售、课程分发问题
      </span>
      <a class="button-text" target="_blank" href="https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9">微信客服</a>
    </div>
    <div class="knowledge1">
      <div class="box">
        <div class="title">构建强大的知识付费平台</div>
        <ul>
          <li>
            <img src="../../assets/images/icon15.png" />
            <span>知识变现</span>
          </li>
          <li>
            <img src="../../assets/images/icon16.png" />
            <span>社群营销</span>
          </li>
          <li>
            <img src="../../assets/images/icon17.png" />
            <span>互动教学</span>
          </li>
          <li>
            <img src="../../assets/images/icon18.png" />
            <span>平台管理</span>
          </li>
          <li>
            <img src="../../assets/images/icon19.png" />
            <span>独立部署</span>
          </li>
          <li>
            <img src="../../assets/images/icon20.png" />
            <span>品牌孵化</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="knowledge2">
      <div class="title">四大变现神器，快速实现知识变现</div>
      <div class="item">
        <div class="top">
          <img src="../../assets/images/page22.jpg" alt srcset />
        </div>
        <div class="btm">
          <h3>付费问答</h3>
          <p>支持60秒超长语音问答，点对点针对教学更准确，知识内容快速变现</p>
          <span>
            <b>·</b>一对一问答，针对需求解决问题
          </span>
          <span>
            <b>·</b>付费偷听，低投入获得更高回报
          </span>
          <span>
            <b>·</b>免费追问，实现知识的深度教学
          </span>
        </div>
      </div>

      <div class="item">
        <div class="top">
          <img src="../../assets/images/page23.jpg" alt srcset />
        </div>
        <div class="btm">
          <h3>付费社群</h3>
          <p>丰富多元的社群管理功能，实现用户社群的精细化运营</p>
          <span>
            <b>·</b>入群门槛，筛选优质付费用户
          </span>
          <span>
            <b>·</b>活动提醒，提前预热学习课程
          </span>
          <span>
            <b>·</b>内容置顶，激励学员提高互动
          </span>
        </div>
      </div>

      <div class="item">
        <div class="top">
          <img src="../../assets/images/page24.jpg" alt srcset />
        </div>
        <div class="btm">
          <h3>教育O2O</h3>
          <p>线上课程引流+线下培训管理，实现多渠道客源的集中沉淀</p>
          <span>
            <b>·</b>活动管理，实时掌控活动流程
          </span>
          <span>
            <b>·</b>课程关联，多渠道客源集中沉淀
          </span>
          <span>
            <b>·</b>线下营销，实现高效的拓客转化
          </span>
        </div>
      </div>

      <div class="item">
        <div class="top">
          <img src="../../assets/images/page25.jpg" alt srcset />
        </div>
        <div class="btm">
          <h3>付费语音直播</h3>
          <p>用声音切入碎片化时间学习，多种授课形式帮助知识服务商高效变现</p>
          <span>
            <b>·</b>语音+图文，互动教学更轻松
          </span>
          <span>
            <b>·</b>录播功能，轻松实现二次变现
          </span>
          <span>
            <b>·</b>提问标识，当场解答学员疑惑
          </span>
        </div>
      </div>
    </div>

    <div class="knowledge2">
      <div class="title">多种展现形式，满足各类知识服务需求</div>
      <div class="item">
        <div class="top">
          <img src="../../assets/images/page26.jpg" />
        </div>
        <div class="itemListTis">
          <div class="itemTis">
            <div class="left">
              <img src="../../assets/images/icon21.png" />
            </div>
            <div class="right">
              <p>付费图文</p>
              <span>支持文字、图片等多种内容表现形式满足各行业教学需求</span>
            </div>
          </div>
          <div class="itemTis">
            <div class="left">
              <img src="../../assets/images/icon22.png" />
            </div>
            <div class="right">
              <p>付费音频</p>
              <span>支持音频课程上传，在线直播充分利用学员碎片时间</span>
            </div>
          </div>
          <div class="itemTis">
            <div class="left">
              <img src="../../assets/images/icon23.png" />
            </div>
            <div class="right">
              <p>付费视频</p>
              <span>支持在线视频播课多维度充分展示知识内容</span>
            </div>
          </div>
          <div class="itemTis">
            <div class="left">
              <img src="../../assets/images/icon24.png" />
            </div>
            <div class="right">
              <p>付费专栏</p>
              <span>聚集同类知识内容，提高学习效率解决课程管理混乱等难题</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="knowledge2 knowledge3">
      <div class="title">多重裂变营销，有流量才有销量</div>
      <div class="item">
        <div class="top">
          <img src="../../assets/images/page28.png" />
        </div>
        <div class="itemListTis">
          <div class="itemTis">
            <div class="left">
              <img src="../../assets/images/icon25.png" />
            </div>
            <div class="right">
              <p>课程分销</p>
              <span>搭载强大分销功能，快速提高课程销量实现客流量及销量的裂变式增长</span>
            </div>
          </div>
          <div class="itemTis">
            <div class="left">
              <img src="../../assets/images/icon26.png" />
            </div>
            <div class="right">
              <p>邀请码、激活码、优惠券</p>
              <span>搭配多种营销玩法交易转化率快速提升</span>
            </div>
          </div>
          <div class="itemTis">
            <div class="left">
              <img src="../../assets/images/icon27.png" />
            </div>
            <div class="right">
              <p>弹窗广告</p>
              <span>首页弹窗功能，增加课程曝光帮助平台打造爆款明星课程</span>
            </div>
          </div>
          <div class="itemTis">
            <div class="left">
              <img src="../../assets/images/icon28.png" />
            </div>
            <div class="right">
              <p>宣传海报</p>
              <span>一键生成宣传海报课程分销更高效</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="knowledge2">
      <div class="title">互动教学，提高用户活跃度及留存</div>
      <div class="item">
        <div class="top">
          <img src="../../assets/images/page29.jpg" />
        </div>
        <div class="itemListTis">
          <div class="itemTis">
            <div class="left">
              <img src="../../assets/images/icon29.png" />
            </div>
            <div class="right">
              <p>直播授课</p>
              <span>图文直播、语音直播、丰富互动形式让知识课堂犹如现场教学</span>
            </div>
          </div>
          <div class="itemTis">
            <div class="left">
              <img src="../../assets/images/icon30.png" />
            </div>
            <div class="right">
              <p>互动回答</p>
              <span>单对单问答式教学；师生点对点互动，精准解答疑问</span>
            </div>
          </div>
          <div class="itemTis">
            <div class="left">
              <img src="../../assets/images/icon31.png" />
            </div>
            <div class="right">
              <p>付费社群</p>
              <span>支持社群与课程关联；打造师生、同窗互动平台</span>
            </div>
          </div>
          <div class="itemTis">
            <div class="left">
              <img src="../../assets/images/icon32.png" />
            </div>
            <div class="right">
              <p>线下活动管理</p>
              <span>一键发布各类线下活动；面对面交流，学习氛围更浓厚</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="knowledge2 knowledge4">
      <div class="title">强大管理功能，实现平台的全面掌控</div>
      <div class="functionBox">
        <ul>
          <li>
            <img src="../../assets/images/icon33.png" />
            <div>
              <span>学员管理</span>
              <p>学员列表，学习记录，用户标签多个管理模块帮助平台更好的进行学员管理</p>
            </div>
          </li>
          <li>
            <img src="../../assets/images/icon34.png" />
            <div>
              <span>店铺设置</span>
              <p>自定义店铺首页功能模块根据品牌形象打造专属于自己的风格</p>
            </div>
          </li>
          <li>
            <img src="../../assets/images/icon35.png" />
            <div>
              <span>课程管理</span>
              <p>各类课程同意管理，提高工作效率,避免排课混乱、资源分配不均等问题发生</p>
            </div>
          </li>
          <li>
            <img src="../../assets/images/icon36.png" />
            <div>
              <span>数据管理</span>
              <p>各项数据实时统计数据沉淀分析，平台状况一目了然</p>
            </div>
          </li>
        </ul>
      </div>

      <div class="knowItem">
        <ul>
          <li>
            <div>
              <img src="../../assets/images/icon37.png" />
              <span>内容付费</span>
              <p>
                通过丰富的内容表现形式，
                <br />帮助知识内容变现
              </p>
            </div>
          </li>
          <li>
            <div>
              <img src="../../assets/images/icon38.png" />
              <span>广告收入</span>
              <p>
                通过数据分析实现精准的
                <br />广告投放，并获得收益
              </p>
            </div>
          </li>
          <li>
            <div>
              <img src="../../assets/images/icon39.png" />
              <span>流量价值</span>
              <p>
                知识+营销，吸引更多流量，
                <br />打造私域流量池
              </p>
            </div>
          </li>
          <li>
            <div>
              <img src="../../assets/images/icon40.png" />
              <span>品牌打造</span>
              <p>
                自建平台打造自有品牌形象
                <br />带来更多收益
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="knowledge2" style="padding-top:0">
      <div class="title">知识付费系统开发，我们很专业</div>
      <ul class="major">
          <li><img src="../../assets/images/icon41.png"><span>快速搭建平台</span></li>
          <li><img src="../../assets/images/icon42.png"><span>自主研发</span></li>
          <li><img src="../../assets/images/icon43.png"><span>版权独立</span></li>
          <li><img src="../../assets/images/icon44.png"><span>多平台展现</span></li>
      </ul>

    </div>

  </div>
</template>

<script>
export default {
  name: "education",

  data() {
    return {};
  },
  mounted() {},

  methods: {}
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #fff;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 1.2rem;
  .knowledgePayBanner {
    background: url("../../assets/images/knowledgePayBanner.gif") no-repeat left
      top;
    background-size: 100% auto;
    height: 9rem;
    padding: 0 0.5rem;
    padding-top: 2rem;
    color: #fff;
    p {
      font-size: 0.6rem;
    }
    span {
      font-size: 0.36rem;
      line-height: 0.6rem;
      display: block;
      padding-top: 0.2rem;
    }
    a {
      background-color: rgb(246, 136, 64);
      width: 3rem;
      height: 0.9rem;
      text-align: center;
      color: #fff;
      font-size: 0.36rem;
      border-radius: 0.9rem;
      margin-top: 0.5rem;
      line-height: .9rem;
      display: block;
    }
  }
  .knowledge1 {
    padding: 0 0.4rem;
    .box {
      background-color: #fff;
      border-radius: 0.1rem;
      margin-top: -2.2rem;
      text-align: center;
      .title {
        padding-top: 0.5rem;
        font-size: 0.52rem;
      }
      ul {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;
        li {
          text-align: center;
          width: 33.333333%;
          padding-top: 0.6rem;
          img {
            width: 1.98rem;
          }
          span {
            display: block;
            padding-top: 0.2rem;
            font-size: 0.4rem;
          }
        }
      }
    }
  }
  .knowledge2 {
    padding-top: 0.7rem;
    .title {
      font-size: 0.52rem;
      padding: 0.5rem 0;
      text-align: center;
    }
    .major{
      display: flex;
      padding: 0 .2rem;
      padding-bottom: .5rem;
      li{
        flex: 1;
        text-align: center;
        img{
          width: 2rem;
        }
        span{
          display: block;
          font-size: .34rem;
        }
      }
    }
    .item {
      .top {
        // padding: 0.3rem 0;
        img {
          width: 100%;
        }
      }
      .btm {
        padding-bottom: 1rem;
        h3 {
          font-size: 0.48rem;
          text-align: center;
          padding: 0.2rem 0;
          font-weight: normal;
        }
        p {
          font-size: 0.36rem;
          color: #999;
          padding: 0 0.55rem;
          padding-bottom: 0.5rem;
          text-align: center;
        }
        span {
          display: block;
          font-size: 0.36rem;
          padding-left: 2.6rem;
          color: #666;
          line-height: 0.6rem;
          b {
            font-size: 0.5rem;
            padding-top: 0.1rem;
          }
        }
      }
    }
    .itemListTis {
      padding: 0.4rem;
      .itemTis {
        display: flex;
        padding: 0.3rem 0;
        .left {
          width: 1rem;
          height: 1rem;
          img {
            width: 100%;
          }
          margin-right: 0.1rem;
        }
        .right {
          p {
            font-size: 0.44rem;
            color: #333;
            padding-bottom: 0.1rem;
          }
          span {
            font-size: 0.36rem;
            color: #666;
          }
        }
      }
    }
  }
  .knowledge3 {
    background: url("../../assets/images/page27.png") no-repeat left 4rem
      #f2f2f2;
    background-size: 100% auto;
    padding-bottom: 0.8rem;
    margin: 0.5rem 0;
  }
  .knowledge4 {
    background: url("../../assets/images/page30.jpg") no-repeat left top;
    background-size: 100% auto;
    padding-top: 0;
    .title {
      padding-top: 0.4rem;
    }
    .functionBox {
      padding: 4.8rem 0.9rem 0 0.9rem;
      ul {
        display: flex;
        flex-wrap: wrap;
        li {
          width: 50%;
          display: flex;
          img {
            width: 1rem;
            height: 1rem;
          }
          div {
            flex: 1;
            span {
              font-size: 0.4rem;
              display: block;
              line-height: 1rem;
            }
            p {
              font-size: 0.36rem;
              color: #666;
              margin-top: -0.2rem;
            }
          }
        }
      }
    }
    .knowItem {
      padding-top: 2rem;
      background: url('../../assets/images/page31.jpg') no-repeat left bottom;
      background-size: 100% auto;
      ul {
        display: flex;
        flex-wrap: wrap;
        padding: 0 .2rem;
        li{
          width: 50%;
          margin-bottom: .4rem;
          div{
            width: 90%;
            box-shadow: 0px 0px 27px 0px rgba(66, 66, 66, 0.2);
            border-radius: .1rem;
            margin: auto;
            overflow: hidden;
            text-align: center;
            padding-bottom: .2rem;
            background-color: #fff;
            img{
              display: block;
              width: .92rem;
              height: .92rem;
              margin:.3rem auto;
            }
            span{
              font-size: .4rem;
              color: #000;
            }
            p{
              font-size: .34rem;
              color: #666;
              padding: .1rem 0;
            }
          }


        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/product/knowledgePay.vue